import React from 'react'
import PropTypes from 'prop-types'

import { Cart, Home, Herth, Feedback } from './Svg'

class Main extends React.Component {
  constructor(props) {
    super(props)
    this.state = {

    }
  }

  render() {
    const { showFeedbackForm, data, cart, leftMenu } = this.props

    // Создаем элементы меню из данных
    const menuItems = data?.menu?.map(item => ({
      key: item.id,
      label: (
        <a href={item.href} style={{ textDecoration: 'none', color: 'inherit' }}>
          {item.pagetitle}
        </a>
      )
    }))

    return (
      <div className='fixed left-0 bottom-0 px-[10px] pb-[10px] w-[100%] z-20'>
        <div className='container flex items-center justify-between'>
          <div className='h-[60px] px-[6px] gap-[21px] flex items-center justify-center rounded-full bg-white shadow-[0_0_35px_-15px_rgba(0,0,0,0.3)]'>
            <div onClick={() => leftMenu()} className='h-[48px] px-[15px] flex-1 flex items-center justify-center gap-[6px] font-[16px] bg-[#5A91FF] text-white rounded-full cursor-pointer'>
              <Home />
              <div>Меню</div>
            </div>

            <a href={data?.favorite_link || ``} className='h-[40px] flex-1 flex items-center justify-center rounded-full cursor-pointer'>
              <Herth />
            </a>
            <div onClick={() => showFeedbackForm()} className='h-[40px] flex-1 flex items-center justify-center rounded-full cursor-pointer'>
              <Feedback />
            </div>
            <a href={data?.notifications_link || ``} className='h-[40px] flex-1 flex items-center justify-center rounded-full cursor-pointer mr-[7px]'>
              <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.0256 3.39502C10.164 3.39502 7.02563 6.53335 7.02563 10.395V13.7667C7.02563 14.4784 6.7223 15.5634 6.36063 16.17L5.01897 18.3984C4.19063 19.775 4.7623 21.3034 6.27897 21.8167C11.3073 23.4967 16.7323 23.4967 21.7606 21.8167C23.1723 21.35 23.7906 19.6817 23.0206 18.3984L21.679 16.17C21.329 15.5634 21.0256 14.4784 21.0256 13.7667V10.395C21.0256 6.54502 17.8756 3.39502 14.0256 3.39502Z" stroke="#AEAEAE" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round"/>
                <path d="M16.1799 3.73367C15.8183 3.62867 15.4449 3.54701 15.0599 3.50034C13.9399 3.36034 12.8666 3.44201 11.8633 3.73367C12.2016 2.87034 13.0416 2.26367 14.0216 2.26367C15.0016 2.26367 15.8416 2.87034 16.1799 3.73367Z" stroke="#AEAEAE" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M17.5234 22.2363C17.5234 24.1613 15.9484 25.7363 14.0234 25.7363C13.0668 25.7363 12.1801 25.3397 11.5501 24.7097C10.9201 24.0797 10.5234 23.193 10.5234 22.2363" stroke="#AEAEAE" strokeWidth="1.5" strokeMiterlimit="10"/>
              </svg>
            </a>
          </div>
          <a href={data?.cart_link || ``} className={`w-[60px] h-[60px] rounded-full flex items-center justify-center shadow-[0_0_35px_-15px_rgba(0,0,0,0.3)]` + ( cart?.total_items > 0 ? ` text-white bg-[#5A91FF]` : ` text-[#AEAEAE] bg-white` ) }>
            <div className='relative'>
              <Cart />
              {cart?.total_items > 0 &&
                <div className='absolute top-[-5px] right-[-5px] w-[20px] h-[20px] rounded-full bg-[#A6DD2F] text-white text-[11px] flex items-center justify-center'>
                  {cart?.total_items}
                </div>
              }
            </div>
          </a>
        </div>
      </div>
    )
  }
}

Main.propTypes = {
  showFeedbackForm: PropTypes.func,
  data: PropTypes.object,
  cart: PropTypes.object,
  leftMenu: PropTypes.func
}

export default Main